module.exports = __webpack_public_path__ + "static/Scorpion_Giant-afa9409448c54731bf241bb10b180465.jpg";